
import { useState, useEffect } from "react";
import { useIOSDetection } from "./use-ios-detection";

interface DeviceInfo {
  isIOS: boolean;
  isAndroid: boolean;
  isMobile: boolean;
  isDesktop: boolean;
}

/**
 * Hook to detect device type (iOS, Android, mobile, desktop)
 * @returns DeviceInfo object with device detection results
 */
export function useDeviceDetection(): DeviceInfo {
  const { isIOS } = useIOSDetection();
  
  const [isAndroid, setIsAndroid] = useState<boolean>(false);
  const [isMobile, setIsMobile] = useState<boolean>(false);
  
  useEffect(() => {
    if (typeof window === 'undefined') return;
    
    // Check for Android
    const userAgent = navigator.userAgent || "";
    const isAndroidDevice = /Android/i.test(userAgent);
    setIsAndroid(isAndroidDevice);
    
    // Check for any mobile device
    const isMobileDevice = /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
    setIsMobile(isMobileDevice || isIOS);
    
  }, [isIOS]);
  
  const isDesktop = !isMobile;
  
  return {
    isIOS,
    isAndroid,
    isMobile,
    isDesktop
  };
}
